import {
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';
import languagesPropType from './languagesPropType.js';
import translate from './translate.js';

class NewPasswordFormField extends React.Component {
  validatePasswordIsValid = () => {
    let {
      language,
      rulesResults,
    } = this.props;

    return rulesResults.every(x => x.pass)
      ? null
      : translate('passwordDoesNotMeetRequirements', language);
  }

  handleChangePassword = (e) => this.props.onChange(e.target.value);

  render() {
    let {
      autoFocus,
      formFieldProps,
      inputProps,
      label,
      language,
      value,
    } = this.props;

    return (
      <FormField
        className="tall-form-group"
        isRequired
        isRequiredErrorMessage={translate('newPasswordRequired', language)}
        label={label ? label : translate('newPassword', language)}
        value={value.trim()}
        validate={[
          this.validatePasswordIsValid
        ]}
        {...formFieldProps}
      >
        <FormControl
          autoFocus={autoFocus}
          onChange={this.handleChangePassword}
          name="password"
          type="password"
          value={value}
          {...inputProps}
        />
      </FormField>
    );
  }
}

NewPasswordFormField.defaultProps = {
  autoFocus: false,
  formFieldProps: {},
  inputProps: {},
  language: languagesPropType.defaultProp,
  value: '',
};

NewPasswordFormField.propTypes = {
  autoFocus: PropTypes.bool,
  formFieldProps: PropTypes.object,
  inputProps: PropTypes.object,
  label: PropTypes.node,
  language: languagesPropType.propType,
  onChange: PropTypes.func.isRequired,
  rulesResults: PropTypes.array,
  value: PropTypes.string.isRequired,
};

export default NewPasswordFormField;